import { useSelector } from 'react-redux';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { hadFreemiumSubscriptionFromSsr } from 'reactApp/modules/billingData/billingData.ssr.selectors';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { createDaysStringPlural, subtractSubscriptionDates } from 'reactApp/modules/billingData/billingData.utils';
import { addPeriodToDate } from 'reactApp/utils/Period';

export const useIsFreemium = (): boolean => {
    const hasFreemiumTariff = !!useSelector(BillingDataSelectors.getFreemiumSubscription);
    const hasNotFreemiumTariff = !!useSelector(BillingDataSelectors.getNotFreemiumSubscription);

    /** Если есть обычный платный тариф, то не показываем фримиум */
    return hasFreemiumTariff && !hasNotFreemiumTariff;
};

export const useFreemiumSubscriptionDays = (): number => {
    const freemiumSubscription: BillingDataSubscriptionInfo | undefined = useSelector(BillingDataSelectors.getFreemiumSubscription);
    if (!freemiumSubscription || !freemiumSubscription.productFreemiumPeriod) {
        return 0;
    }

    return subtractSubscriptionDates(freemiumSubscription.start, freemiumSubscription.productFreemiumPeriod);
};

export const useFreemiumDaysString = (): string | undefined => {
    const freemiumDays: number = useFreemiumSubscriptionDays();

    return createDaysStringPlural(freemiumDays);
};

export const useFreemiumExpiresDate = (): number | null => {
    const freemiumSubscription: BillingDataSubscriptionInfo | undefined = useSelector(BillingDataSelectors.getFreemiumSubscription);
    if (!freemiumSubscription || !freemiumSubscription.productFreemiumPeriod) {
        return null;
    }

    return addPeriodToDate(freemiumSubscription.start, freemiumSubscription.productFreemiumPeriod);
};

export const useHadFreemiumSubscription = (): boolean => {
    return useSelector(hadFreemiumSubscriptionFromSsr);
};
